<div class="notification-wrapper">
	<app-toast
		key="app-notification"
		[position]="position"
		data-qa="toast-notification"
	></app-toast>
</div>
